const getLimitedInventoryTrimsGtm = (trims, trimsInventoryStatus) => {
    if (!trimsInventoryStatus)
        return '';
    const lowInventoryTrimKeys = trimsInventoryStatus
        .filter(({ inventoryStatus }) => inventoryStatus === 'lowInventory')
        .map(trim => trim === null || trim === void 0 ? void 0 : trim.trimKey);
    const lowInventoryTrims = trims
        .filter(trim => lowInventoryTrimKeys.includes(trim === null || trim === void 0 ? void 0 : trim.trimKey))
        .map(trim => trim === null || trim === void 0 ? void 0 : trim.trimName);
    return lowInventoryTrims.join(', ');
};
export default getLimitedInventoryTrimsGtm;
